/**
 * Translation resources, one module per namespace per locale.
 *
 * zh is the reference shape: every en namespace is typed `typeof zh`, so a key
 * added to one locale and not the other fails the type check. Namespaces are
 * added here as each part of the UI is migrated.
 */
import enChat from './locales/en/chat';
import enCpa from './locales/en/cpa';
import enCommon from './locales/en/common';
import enEval from './locales/en/eval';
import enSettings from './locales/en/settings';
import enShell from './locales/en/shell';
import enSkills from './locales/en/skills';
import enTasks from './locales/en/tasks';
import enWorkspace from './locales/en/workspace';
import legacyChat from './locales/legacy/chat';
import legacyCpa from './locales/legacy/cpa';
import legacyCommon from './locales/legacy/common';
import legacyEval from './locales/legacy/eval';
import legacySettings from './locales/legacy/settings';
import legacyShell from './locales/legacy/shell';
import legacySkills from './locales/legacy/skills';
import legacyTasks from './locales/legacy/tasks';
import legacyWorkspace from './locales/legacy/workspace';
import zhChat from './locales/zh/chat';
import zhCpa from './locales/zh/cpa';
import zhCommon from './locales/zh/common';
import zhEval from './locales/zh/eval';
import zhSettings from './locales/zh/settings';
import zhShell from './locales/zh/shell';
import zhSkills from './locales/zh/skills';
import zhTasks from './locales/zh/tasks';
import zhWorkspace from './locales/zh/workspace';

export const resources = {
  zh: { common: zhCommon, shell: zhShell, chat: zhChat, workspace: zhWorkspace, tasks: zhTasks, skills: zhSkills, settings: zhSettings, eval: zhEval, cpa: zhCpa },
  en: { common: enCommon, shell: enShell, chat: enChat, workspace: enWorkspace, tasks: enTasks, skills: enSkills, settings: enSettings, eval: enEval, cpa: enCpa },
} as const;

export type Locale = keyof typeof resources;

export const LOCALES = Object.keys(resources) as Locale[];

/**
 * The language the UI renders while UI_I18N_ENABLED is off: a frozen copy of the
 * text the UI showed before the zh/en switch (locales/legacy), so turning the
 * switch off changes nothing for users. Not a selectable locale. Delete with the flag.
 */
export const LEGACY_LANGUAGE = 'legacy';

export const legacyResources: (typeof resources)['zh'] = {
  common: legacyCommon,
  shell: legacyShell,
  chat: legacyChat,
  workspace: legacyWorkspace,
  tasks: legacyTasks,
  skills: legacySkills,
  settings: legacySettings,
  eval: legacyEval,
  cpa: legacyCpa,
};

export const DEFAULT_NS = 'common';
